import errors from './errors/index.js';
import translation from './translation/index.js';
const ptPT = Object.freeze({
    translation,
    errors,
});
export default ptPT;
